import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HomeComponent } from './features/home/home.component';
import { QuienesSomosComponent } from './features/quienes-somos/quienes-somos.component';
import { SistemaGesvatecComponent } from './features/sistema-gesvatec/sistema-gesvatec.component';
import { EtiquetaComponent } from './features/etiqueta/etiqueta.component';
import { ProductosGestionadosComponent } from './features/productos-gestionados/productos-gestionados.component';
import { CertificadoComponent } from './features/certificado/certificado.component';
import { ClientesComponent } from './features/clientes/clientes.component';
import { SoporteComponent } from './features/soporte/soporte.component';
import { ContactoComponent } from './features/contacto/contacto.component';
import { LegalPageComponent } from './features/legal/legal-page.component';
import { DemoModalComponent } from './shared/components/demo-modal/demo-modal.component';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { VerificarCertificadoComponent } from './features/verificar-certificado/verificar-certificado.component';
import { StepperComponent } from './shared/components/stepper/stepper.component';
import { TrazabilidadCertificadoComponent } from './features/trazabilidad-certificado/trazabilidad-certificado.component';

export function createTranslateLoader(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(localeEs);

@NgModule({
  declarations: [AppComponent, HeaderComponent, FooterComponent, HomeComponent, QuienesSomosComponent, SistemaGesvatecComponent, EtiquetaComponent, ProductosGestionadosComponent, CertificadoComponent, ClientesComponent, SoporteComponent, ContactoComponent, LegalPageComponent, DemoModalComponent, SpinnerComponent, VerificarCertificadoComponent, StepperComponent, TrazabilidadCertificadoComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
